{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.Injections;

{$IFDEF PAS2JS}
{$mode DELPHI}
{$modeswitch externalclass}
{$ENDIF}

interface
uses
  Classes, web, JS, WEBLib.Controls, Types, System.SysUtils,
  libdatagrid,
  jsdelphisystem, WEBLib.DataGrid.libjs;

type
  TEmbeddedJSInjections = class {$IFDEF PAS2JS}external name 'document.agGridInjections'{$ENDIF} (TJSObject)
  public
{$REGION 'JavaScript Exports'}
    class var TMSInjectionFactory: TJSFunction;
    class procedure LoadInjectionModule(api: Pointer);
    class procedure InitInjectionModule(tmsGrid: Pointer; agGrid: TJSAgGrid);
{$ENDREGION}
  end;

  TDGGridInjections = class(TEmbeddedJavaScript)
  public
    function ModuleName: String; override;
    function Source: String; override;
    function GlobalVariableName: String; override;
    class function GetExports: TDGGridInjections;
  end;

implementation


{ TDGGridInjections }

class function TDGGridInjections.GetExports: TDGGridInjections;
begin
  Result := nil;
{$IFDEF PAS2JS}asm
  if (typeof(document.agGridInjections) != "undefined")
    this.Result = document.agGridInjections;
end;{$ENDIF}
end;

function TDGGridInjections.GlobalVariableName: String;
begin
  Result := 'agGridInjections';
end;

function TDGGridInjections.ModuleName: String;
begin
  Result := ClassName;
end;

function TDGGridInjections.Source: String;
var
  S: String;
begin
  S := '';
{$REGION 'TDGGridInjections'}
{$IFDEF PAS2JS}
  S:=S+'class TMSInjectionFactory extends document.agGrid.BeanStub {'+#$D#$A;
  S:=S+'    constructor() {'+#$D#$A;
  S:=S+'        super(...arguments),'+#$D#$A;
  S:=S+'            this.beanName = ''customTMSInjectionFactory'';'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    postConstruct() {'+#$D#$A;
  S:=S+'        var _a, _b, _c, _d;'+#$D#$A;
  S:=S+'        const dragService = this.getDragService();'+#$D#$A;
  S:=S+'        if (dragService)'+#$D#$A;
  S:=S+'            dragService.onMouseDown = this.override_onMouseDown.bind(this);'+#$D#$A;
  S:=S+'        const popupService = this.getPopupService();'+#$D#$A;
  S:=S+'        if (popupService) {'+#$D#$A;
  S:=S+'            popupService.addEventListenersToPopup = this.override_addEventListenersToPopup.bind(this);'+#$D#$A;
  S:=S+'            this.popupEventTarget = (_d = (_c = (_b = (_a = this.beans) === null || _a === void 0 ? void 0 : _a.eGridDiv) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.parentElement;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    preWireBeans(beans) {'+#$D#$A;
  S:=S+'        super.preWireBeans(beans);'+#$D#$A;
  S:=S+'        if (typeof (this.beans) == "undefined")'+#$D#$A;
  S:=S+'            this.beans = beans;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getDragService() {'+#$D#$A;
  S:=S+'        var _a, _b;'+#$D#$A;
  S:=S+'        if (typeof ((_a = this.beans) === null || _a === void 0 ? void 0 : _a.dragSvc) == "object")'+#$D#$A;
  S:=S+'            return (this.beans.dragSvc);'+#$D#$A;
  S:=S+'        else if (typeof ((_b = this.beans) === null || _b === void 0 ? void 0 : _b.dragService) == "object")'+#$D#$A;
  S:=S+'            return (this.beans.dragService);'+#$D#$A;
  S:=S+'        return (null);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getPopupService() {'+#$D#$A;
  S:=S+'        var _a, _b;'+#$D#$A;
  S:=S+'        if (typeof ((_a = this.beans) === null || _a === void 0 ? void 0 : _a.popupSvc) == "object")'+#$D#$A;
  S:=S+'            return (this.beans.popupSvc);'+#$D#$A;
  S:=S+'        else if (typeof ((_b = this.beans) === null || _b === void 0 ? void 0 : _b.popupService) == "object")'+#$D#$A;
  S:=S+'            return (this.beans.popupService);'+#$D#$A;
  S:=S+'        return (null);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    override_addEventListenersToPopup(popupParams) {'+#$D#$A;
  S:=S+'        var _a, _b, _c, _d;'+#$D#$A;
  S:=S+'        const that = this.getPopupService();'+#$D#$A;
  S:=S+'        var eDocument = that.gos.getDocument();'+#$D#$A;
  S:=S+'        const ePopupParent = that.getPopupParent();'+#$D#$A;
  S:=S+'        if (typeof ((_d = (_c = (_b = (_a = this.gos) === null || _a === void 0 ? void 0 : _a.gridOptions) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.FParent) === null || _d === void 0 ? void 0 : _d.FElement) == "object"'+#$D#$A;
  S:=S+'            && this.gos.gridOptions.context.FParent.FElement != null) {'+#$D#$A;
  S:=S+'            eDocument = this.gos.gridOptions.context.FParent.FElement;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        const { wrapperEl, eChild: popupEl, closedCallback, afterGuiAttached, closeOnEsc, modal } = popupParams;'+#$D#$A;
  S:=S+'        let popupHidden = false;'+#$D#$A;
  S:=S+'        const hidePopupOnKeyboardEvent = (event) => {'+#$D#$A;
  S:=S+'            const AG_GRID_STOP_PROPAGATION = ''__ag_Grid_Stop_Propagation'';'+#$D#$A;
  S:=S+'            if (!wrapperEl.contains(that.gos.getActiveDomElement())) {'+#$D#$A;
  S:=S+'                return;'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            const key = event.key;'+#$D#$A;
  S:=S+'            if (key === "Escape" && !(event[AG_GRID_STOP_PROPAGATION] === true)) {'+#$D#$A;
  S:=S+'                removeListeners({ keyboardEvent: event });'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'        };'+#$D#$A;
  S:=S+'        const hidePopupOnMouseEvent = (event) => removeListeners({ mouseEvent: event });'+#$D#$A;
  S:=S+'        const hidePopupOnTouchEvent = (event) => removeListeners({ touchEvent: event });'+#$D#$A;
  S:=S+'        const removeListeners = (popupParams = {}) => {'+#$D#$A;
  S:=S+'            const { mouseEvent, touchEvent, keyboardEvent, forceHide } = popupParams;'+#$D#$A;
  S:=S+'            if (!forceHide &&'+#$D#$A;
  S:=S+'                (that.isEventFromCurrentPopup({ mouseEvent, touchEvent }, popupEl) ||'+#$D#$A;
  S:=S+'                    popupHidden)) {'+#$D#$A;
  S:=S+'                return;'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            popupHidden = true;'+#$D#$A;
  S:=S+'            ePopupParent.removeChild(wrapperEl);'+#$D#$A;
  S:=S+'            eDocument.removeEventListener(''keydown'', hidePopupOnKeyboardEvent);'+#$D#$A;
  S:=S+'            eDocument.removeEventListener(''mousedown'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'            eDocument.removeEventListener(''touchstart'', hidePopupOnTouchEvent);'+#$D#$A;
  S:=S+'            eDocument.removeEventListener(''contextmenu'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'            that.eventService.removeEventListener(''dragStarted'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'            if (closedCallback) {'+#$D#$A;
  S:=S+'                closedCallback(mouseEvent || touchEvent || keyboardEvent);'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            that.removePopupFromPopupList(popupEl);'+#$D#$A;
  S:=S+'        };'+#$D#$A;
  S:=S+'        if (afterGuiAttached) {'+#$D#$A;
  S:=S+'            afterGuiAttached({ hidePopup: removeListeners });'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        window.setTimeout(() => {'+#$D#$A;
  S:=S+'            if (closeOnEsc) {'+#$D#$A;
  S:=S+'                if (typeof (wrapperEl) != "undefined")'+#$D#$A;
  S:=S+'                    wrapperEl.addEventListener(''keydown'', hidePopupOnKeyboardEvent);'+#$D#$A;
  S:=S+'                else'+#$D#$A;
  S:=S+'                    eDocument.addEventListener(''keydown'', hidePopupOnKeyboardEvent);'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            if (modal) {'+#$D#$A;
  S:=S+'                eDocument.addEventListener(''mousedown'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'                that.eventService.addEventListener(''dragStarted'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'                eDocument.addEventListener(''touchstart'', hidePopupOnTouchEvent);'+#$D#$A;
  S:=S+'                eDocument.addEventListener(''contextmenu'', hidePopupOnMouseEvent);'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'        }, 0);'+#$D#$A;
  S:=S+'        return removeListeners;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    override_onMouseDown(params, mouseEvent) {'+#$D#$A;
  S:=S+'        var _a;'+#$D#$A;
  S:=S+'        const that = this.getDragService();'+#$D#$A;
  S:=S+'        if (!that)'+#$D#$A;
  S:=S+'            throw new Error("override_onMouseDown() - Unable to get dragService!");'+#$D#$A;
  S:=S+'        const a = mouseEvent;'+#$D#$A;
  S:=S+'        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent))'+#$D#$A;
  S:=S+'            return;'+#$D#$A;
  S:=S+'        if (a._alreadyProcessedByDragService)'+#$D#$A;
  S:=S+'            return;'+#$D#$A;
  S:=S+'        if (a._alreadyProcessedByDragService = !0,'+#$D#$A;
  S:=S+'            0 !== mouseEvent.button)'+#$D#$A;
  S:=S+'            return;'+#$D#$A;
  S:=S+'        that.shouldPreventMouseEvent(mouseEvent) && mouseEvent.preventDefault();'+#$D#$A;
  S:=S+'        that.currentDragParams = params;'+#$D#$A;
  S:=S+'        that.dragging = false;'+#$D#$A;
  S:=S+'        that.mouseStartEvent = mouseEvent;'+#$D#$A;
  S:=S+'        that.startTarget = mouseEvent.target;'+#$D#$A;
  S:=S+'        var target = (_a = this.beans.eGridDiv.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;'+#$D#$A;
  S:=S+'        var dragOverlayDiv = null;'+#$D#$A;
  S:=S+'        dragOverlayDiv = document.createElement("div");'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.top = 0;'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.left = 0;'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.height = "100vh";'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.width = "100vw";'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.zIndex = "9999999";'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.position = "absolute";'+#$D#$A;
  S:=S+'        dragOverlayDiv.style.pointerEvents = "none";'+#$D#$A;
  S:=S+'        document.body.appendChild(dragOverlayDiv);'+#$D#$A;
  S:=S+'        const _mouseMove = (mouseEvent) => {'+#$D#$A;
  S:=S+'            console.log("override_onMouseMove(" + mouseEvent.x + ", " + mouseEvent.y + ")");'+#$D#$A;
  S:=S+'            if ((mouseEvent.buttons & 0x00000001) != 1) {'+#$D#$A;
  S:=S+'                that.onMouseUp(mouseEvent, params.eElement);'+#$D#$A;
  S:=S+'                if (dragOverlayDiv) {'+#$D#$A;
  S:=S+'                    dragOverlayDiv.remove();'+#$D#$A;
  S:=S+'                    dragOverlayDiv = null;'+#$D#$A;
  S:=S+'                }'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            else {'+#$D#$A;
  S:=S+'                dragOverlayDiv.style.pointerEvents = "auto";'+#$D#$A;
  S:=S+'                that.onMouseMove(mouseEvent, params.eElement);'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'        };'+#$D#$A;
  S:=S+'        const _mouseUp = (mouseEvent) => {'+#$D#$A;
  S:=S+'            console.log("override_onMouseUp(" + mouseEvent.x + ", " + mouseEvent.y + ")");'+#$D#$A;
  S:=S+'            if (dragOverlayDiv) {'+#$D#$A;
  S:=S+'                dragOverlayDiv.remove();'+#$D#$A;
  S:=S+'                dragOverlayDiv = null;'+#$D#$A;
  S:=S+'            }'+#$D#$A;
  S:=S+'            that.onMouseUp(mouseEvent, params.eElement);'+#$D#$A;
  S:=S+'        };'+#$D#$A;
  S:=S+'        const _contextMenu = mouseEvent => mouseEvent.preventDefault();'+#$D#$A;
  S:=S+'        const _keyUp = mouseEvent => {'+#$D#$A;
  S:=S+'            mouseEvent.key === "Escape" && that.cancelDrag(params.eElement);'+#$D#$A;
  S:=S+'        };'+#$D#$A;
  S:=S+'        console.log("override_onMouseDown(" + mouseEvent.x + ", " + mouseEvent.y + ")");'+#$D#$A;
  S:=S+'        if (true) {'+#$D#$A;
  S:=S+'            const tempEvents = [{'+#$D#$A;
  S:=S+'                    target: target,'+#$D#$A;
  S:=S+'                    type: "mousemove",'+#$D#$A;
  S:=S+'                    listener: _mouseMove'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: target,'+#$D#$A;
  S:=S+'                    type: "mouseup",'+#$D#$A;
  S:=S+'                    listener: _mouseUp'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: target,'+#$D#$A;
  S:=S+'                    type: "contextmenu",'+#$D#$A;
  S:=S+'                    listener: _contextMenu'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: target,'+#$D#$A;
  S:=S+'                    type: "keydown",'+#$D#$A;
  S:=S+'                    listener: _keyUp'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: dragOverlayDiv,'+#$D#$A;
  S:=S+'                    type: "mousemove",'+#$D#$A;
  S:=S+'                    listener: _mouseMove'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: dragOverlayDiv,'+#$D#$A;
  S:=S+'                    type: "mouseup",'+#$D#$A;
  S:=S+'                    listener: _mouseUp'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: dragOverlayDiv,'+#$D#$A;
  S:=S+'                    type: "contextmenu",'+#$D#$A;
  S:=S+'                    listener: _contextMenu'+#$D#$A;
  S:=S+'                }, {'+#$D#$A;
  S:=S+'                    target: dragOverlayDiv,'+#$D#$A;
  S:=S+'                    type: "keydown",'+#$D#$A;
  S:=S+'                    listener: _keyUp'+#$D#$A;
  S:=S+'                }];'+#$D#$A;
  S:=S+'            that.addTemporaryEvents(tempEvents);'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        if (params.dragStartPixels === 0)'+#$D#$A;
  S:=S+'            that.onMouseMove(mouseEvent, params.eElement);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TMSInjectionFactory = TMSInjectionFactory;'+#$D#$A;
  S:=S+'function LoadInjectionModule(api) {'+#$D#$A;
  S:=S+'    var version = null;'+#$D#$A;
  S:=S+'    if (typeof (api.ModuleRegistry.currentModuleVersion) != "undefined")'+#$D#$A;
  S:=S+'        version = api.ModuleRegistry.currentModuleVersion;'+#$D#$A;
  S:=S+'    else if (typeof (api.AllCommunityModule.version) != "undefined")'+#$D#$A;
  S:=S+'        version = api.AllCommunityModule.version;'+#$D#$A;
  S:=S+'    var TMSInjectionModule = {'+#$D#$A;
  S:=S+'        moduleName: "TMSInjectionModule",'+#$D#$A;
  S:=S+'        version: version,'+#$D#$A;
  S:=S+'        beans: [TMSInjectionFactory],'+#$D#$A;
  S:=S+'        validate: () => { return ({ isValid: true }); }'+#$D#$A;
  S:=S+'    };'+#$D#$A;
  S:=S+'    if (typeof (api.ModuleRegistry.__register) == "function")'+#$D#$A;
  S:=S+'        api.ModuleRegistry.__register(TMSInjectionModule, false, void 0);'+#$D#$A;
  S:=S+'    else'+#$D#$A;
  S:=S+'        api.ModuleRegistry.registerModules([TMSInjectionModule]);'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.LoadInjectionModule = LoadInjectionModule;'+#$D#$A;
  S:=S+'function InitInjectionModule(tmsGrid, agGrid) {'+#$D#$A;
  S:=S+'    if (typeof (agGrid.setGridOption) != "undefined") {'+#$D#$A;
  S:=S+'        agGrid.setGridOption("context", tmsGrid);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.InitInjectionModule = InitInjectionModule;'+#$D#$A;
{$ENDIF}
{$ENDREGION}
  Result := S;
end;

{$IFNDEF PAS2JS}
{ TEmbeddedJSInjections }

class procedure TEmbeddedJSInjections.LoadInjectionModule(api: Pointer);
begin
end;

class procedure TEmbeddedJSInjections.InitInjectionModule(tmsGrid: Pointer; agGrid: TJSAgGrid);
begin
end;

{$ENDIF}

initialization

  TTMSModuleLoader.RegisterEmbeddedJavaScript(TDGGridInjections.Create);

end.
